// keys in local storage
export const LS_KEYS = {
  JWT_TOKEN: 'jwtToken',
  ORDERS_IN_CACHE: 'pro-kz-orders-cache',
  THEME: 'proKZTheme',
};